import React, { Fragment, useEffect, useState } from "react";
import {
  Paper,
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Button,
} from "@mui/material";
import { getSession } from "../../apis/Session";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import DataEmisor from "./DataEmisor";
import OperacionComercial from "./OperacionComercial";
import ActividadesEconomicas from "./ActividadesEconomicas";

import ModalLisDep from "./ModalLisDep";
import ModalLisDis from "./ModalLisDis";
import ModalLisCiu from "./ModalLisCiu";
import ModalLisActEco from "./ModalLisActEco";

import { grabaCfgFacte, getCfgFacte } from "../../apis/api";

const cfini = {
  tipogen: "2",
  rucemi: "",
  dvemi: "",
  tipcontrib: "1",
  nomemi: "",
  nomfanemi: "",
  diremi: "",
  diremi1: "",
  diremi2: "",
  numcas: "",
  telemi: "",
  mailemi: "",
  depemi: "1",
  depemidesc: "CAPITAL",
  disemi: "1",
  disemidesc: "ASUNCION (DISTRITO)",
  ciuemi: "1",
  ciuemidesc: "ASUNCION (DISTRITO)",
  tipotran: "1",
  tipotrandesc: "Venta de mercadería",
  tipoimp: "1",
  tipoimpdesc: "IVA",
  tiporeg: "8",
  numtim: "",
  fecinit: "",
  tipoidresp: "1",
  numidresp: "",
  nomresp: "",
  cargresp: "",
  detActi: [],
  digestvalue: "",
};

const FacteConfigMUI = (props) => {
  const { open, handleClose } = props;

  const [activeStep, setActiveStep] = useState(0);
  const steps = [
    "Datos del Emisor",
    "Operación Comercial",
    "Actividades Económicas",
  ];

  const [GActEco, setGActEco] = useState({
    codigo: "",
    descripcion: "",
    primario: false,
  });
  const [actividades, setActividades] = useState([]);
  const [facturae, setFacturae] = useState(cfini);
  const [upper, setUpper] = useState(false);
  const [tooltip, setTooltip] = useState(false);

  const [listaDep, setListaDep] = useState(
    JSON.parse(localStorage.getItem("listaDep"))
  );
  const [listaDis, setListaDis] = useState(
    JSON.parse(localStorage.getItem("listaDis"))
  );
  const [listaCiu, setListaCiu] = useState(
    JSON.parse(localStorage.getItem("listaCiu"))
  );
  let list_with_filter = JSON.parse(localStorage.getItem("listaActEco"));

  const [validation, setValidation] = useState({
    rucemi: "",
    dvemi: "",
    nomemi: "",
    diremi: "",
    numcas: "",
    telemi: "",
    mailemi: "",
    depemi: "",
    disemi: "",
    ciuemi: "",
    numtim: "",
    fecinit: "",
    numidresp: "",
    nomresp: "",
    cargresp: "",
  });

  // Modal states and toggles
  const [modalDepOpen, setModalDepOpen] = useState(false);
  const toggleDepModal = () => {
    setModalDepOpen(!modalDepOpen);
  };

  const [modalDisOpen, setModalDisOpen] = useState(false);
  const toggleDisModal = () => {
    if (facturae.depemi) {
      setListaDis(
        JSON.parse(localStorage.getItem("listaDis")).filter((item) => {
          return item.codDep === facturae.depemi;
        })
      );
      setModalDisOpen(!modalDisOpen);
    } else {
      toast.warning("Debe seleccionar un departamento primero.", {
        position: "top-right",
      });
    }
  };

  const [modalCiuOpen, setModalCiuOpen] = useState(false);
  const toggleCiuModal = () => {
    if (facturae.disemi) {
      setListaCiu(
        JSON.parse(localStorage.getItem("listaCiu")).filter((item) => {
          return item.codDis === facturae.disemi;
        })
      );
      setModalCiuOpen(!modalCiuOpen);
    } else {
      toast.warning("Debe seleccionar un distrito primero.", {
        position: "top-right",
      });
    }
  };

  const [modalActOpen, setModalActOpen] = useState(false);
  const toggleActModal = () => {
    setModalActOpen(!modalActOpen);
  };

  const [searchActEco, setSearchActEco] = useState("");
  if (searchActEco) {
    list_with_filter = list_with_filter.filter(
      (lista) =>
        lista.codigo.toLowerCase().includes(searchActEco.toLowerCase()) ||
        lista.descripcion.toLowerCase().includes(searchActEco.toLowerCase())
    );
  } else {
    list_with_filter = JSON.parse(localStorage.getItem("listaActEco"));
  }

  const selecDep = (item) => {
    setFacturae({
      ...facturae,
      depemi: item.codDep,
      depemidesc: item.departamento,
      disemi: "",
      disemidesc: "",
      ciuemi: "",
      ciuemidesc: "",
    });
    setModalDepOpen(false);
    setValidation({ ...validation, depemi: "" });
  };

  const selecDis = (item) => {
    setFacturae({
      ...facturae,
      disemi: item.codDis,
      disemidesc: item.distrito,
      ciuemi: "",
      ciuemidesc: "",
    });
    setModalDisOpen(false);
    setValidation({ ...validation, disemi: "" });
  };

  const selecCiu = (item) => {
    setFacturae({
      ...facturae,
      ciuemi: item.codCid,
      ciuemidesc: item.ciudad,
    });
    setModalCiuOpen(false);
    setValidation({ ...validation, ciuemi: "" });
  };

  const selecAct = (item) => {
    setGActEco({
      ...GActEco,
      codigo: item.codigo,
      descripcion: upper ? item.descripcion.toUpperCase() : item.descripcion,
    });
    setSearchActEco("");
    setModalActOpen(false);
  };

  const addActividad = () => {
    if (GActEco.codigo !== "") {
      const newActivity = {
        ...GActEco,
        descripcion: upper
          ? GActEco.descripcion.toUpperCase()
          : GActEco.descripcion,
      };
      setActividades([...actividades, newActivity]);
      setGActEco({ codigo: "", descripcion: "", primario: false });
    } else {
      toast.warning("Debe seleccionar una actividad económica.", {
        position: "top-right",
      });
    }
  };

  const eliminarActividad = (row) => {
    setActividades((prevActivities) =>
      prevActivities.filter((_, index) => index !== row.id)
    );
  };

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setFacturae({ ...facturae, [name]: value });

    let error = "";
    if (name === "rucemi" && value === "") error = "Debe ingresar el ruc";
    else if (name === "dvemi" && value === "")
      error = "Debe ingresar el dígito verificador";
    else if (name === "nomemi" && value === "")
      error = "Debe ingresar el nombre";
    else if (name === "diremi" && value === "")
      error = "Debe ingresar la dirección";
    else if (name === "numcas" && value === "")
      error = "Debe ingresar el número de casa";
    else if (name === "mailemi" && value === "")
      error = "Debe ingresar el email";
    else if (name === "depemi" && value === "")
      error = "Debe ingresar el departamento";
    else if (name === "disemi" && value === "")
      error = "Debe ingresar el distrito";
    else if (name === "ciuemi" && value === "")
      error = "Debe ingresar la ciudad";
    else if (name === "numtim" && value === "")
      error = "Debe ingresar el timbrado";
    else if (name === "fecinit" && value === "")
      error = "Debe ingresar la fecha de vencimiento de timbrado";
    else if (name === "numidresp" && value === "")
      error = "Debe ingresar el número de documento";
    else if (name === "nomresp" && value === "")
      error = "Debe ingresar el nombre";
    else if (name === "cargresp" && value === "")
      error = "Debe ingresar el cargo";

    setValidation((prev) => ({ ...prev, [name]: error }));

    if (name === "tipotran") {
      const selectedOption = evt.target.options[evt.target.selectedIndex];
      setFacturae((prev) => ({ ...prev, tipotrandesc: selectedOption.text }));
    } else if (name === "tipoimp") {
      const selectedOption = evt.target.options[evt.target.selectedIndex];
      setFacturae((prev) => ({ ...prev, tipoimpdesc: selectedOption.text }));
    } else if (name === "tiporeg") {
      const selectedOption = evt.target.options[evt.target.selectedIndex];
      setFacturae((prev) => ({ ...prev, tiporegdesc: selectedOption.text }));
    }
  };

  const handleNext = () => {
    let currentStepValidationPassed = false;
    switch (activeStep) {
      case 0: // Datos del Emisor
        if (
          !validation.rucemi &&
          !validation.dvemi &&
          !validation.nomemi &&
          !validation.diremi &&
          !validation.numcas &&
          !validation.mailemi &&
          !validation.depemi &&
          !validation.disemi &&
          !validation.ciuemi
        ) {
          currentStepValidationPassed = true;
        } else {
          toast.warning(`POR FAVOR COMPLETE LOS CAMPOS REQUERIDOS del Emisor`, {
            position: "top-right",
          });
        }
        break;
      case 1: // Operación Comercial
        if (
          !validation.numtim &&
          !validation.fecinit &&
          !validation.numidresp &&
          !validation.nomresp &&
          !validation.cargresp
        ) {
          currentStepValidationPassed = true;
        } else {
          toast.warning(
            `POR FAVOR COMPLETE LOS CAMPOS REQUERIDOS de Operación Comercial`,
            { position: "top-right" }
          );
        }
        break;
      case 2: // Actividades Económicas
        if (actividades.length === 0) {
          toast.warning(`DEBE INGRESAR AL MENOS UNA ACTIVIDAD`, {
            position: "top-right",
          });
        } else {
          currentStepValidationPassed = true;
        }
        break;
      default:
        currentStepValidationPassed = false;
    }

    if (currentStepValidationPassed) {
      if (activeStep === steps.length - 1) {
        grabarFactuConf();
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    }
  };

  const tipoTranOptions = [
    { value: "1", text: "Venta de mercadería" },
    { value: "2", text: "Prestación de servicios" },
    { value: "3", text: "Mixto (Venta de mercadería y servicios)" },
    { value: "4", text: "Venta de activo fijo" },
    { value: "5", text: "Venta de divisas" },
    { value: "6", text: "Compra de divisas" },
    { value: "7", text: "Promoción o entrega de muestras" },
    { value: "8", text: "Donación" },
    { value: "9", text: "Anticipo" },
    { value: "10", text: "Compra de productos" },
    { value: "11", text: "Compra de servicios" },
    { value: "12", text: "Venta de crédito fiscal" },
    { value: "13", text: "Muestras médicas (Art. 3 RG 24/2014)" },
  ];

  const tipoImpOptions = [
    { value: "1", text: "IVA" },
    { value: "2", text: "ISC" },
    { value: "3", text: "Renta" },
    { value: "4", text: "Ninguno" },
    { value: "5", text: "IVA - Renta" },
  ];

  const tipoRegOptions = [
    { value: "1", text: "Régimen de Turismo" },
    { value: "2", text: "Importador" },
    { value: "3", text: "Exportador" },
    { value: "4", text: "Maquila" },
    { value: "5", text: "Ley N° 60/90" },
    { value: "6", text: "Régimen del Pequeño Productor" },
    { value: "7", text: "Régimen del Mediano Productor" },
    { value: "8", text: "Régimen Contable" },
  ];

  const handleChangeSel = (evt) => {
    const { name, value } = evt.target;
    setFacturae({ ...facturae, [name]: value });
    if (name === "tipotran") {
      const selectedOption = tipoTranOptions.find(
        (option) => option.value === value
      );
      if (selectedOption) {
        setFacturae((prev) => ({ ...prev, tipotrandesc: selectedOption.text }));
      }
    } else if (name === "tipoimp") {
      const selectedOption = tipoImpOptions.find(
        (option) => option.value === value
      );
      if (selectedOption) {
        setFacturae((prev) => ({ ...prev, tipoimpdesc: selectedOption.text }));
      }
    } else if (name === "tiporeg") {
      const selectedOption = tipoRegOptions.find(
        (option) => option.value === value
      );
      if (selectedOption) {
        setFacturae((prev) => ({ ...prev, tiporegdesc: selectedOption.text }));
      }
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const grabarFactuConf = async () => {
    if (!facturae.fecinit) {
      return toast.warning("Debe agregar una fecha de inicio de timbrado");
    }
    let cnf = {
      tipogen: "2",
      rucemi: facturae.rucemi,
      dvemi: facturae.dvemi,
      tipcontrib: facturae.tipcontrib,
      nomemi: facturae.nomemi,
      nomfanemi: facturae.nomfanemi,
      diremi: facturae.diremi,
      diremi1: facturae.diremi1,
      diremi2: facturae.diremi2,
      numcas: facturae.numcas,
      telemi: facturae.telemi,
      mailemi: facturae.mailemi,
      depemi: facturae.depemi,
      depemidesc: facturae.depemidesc,
      disemi: facturae.disemi,
      disemidesc: facturae.disemidesc,
      ciuemi: facturae.ciuemi,
      ciuemidesc: facturae.ciuemidesc,
      tipotran: facturae.tipotran,
      tipotrandesc: facturae.tipotrandesc,
      tipoimp: facturae.tipoimp,
      tipoimpdesc: facturae.tipoimpdesc,
      tiporeg: facturae.tiporeg,
      numtim: facturae.numtim,
      fecinit: facturae.fecinit,
      tipoidresp: facturae.tipoidresp,
      numidresp: facturae.numidresp,
      nomresp: facturae.nomresp,
      cargresp: facturae.cargresp,
      detActi: actividades,
      uppercase: facturae.uppercase,
      digestvalue: "",
    };
    try {
      await grabaCfgFacte(cnf);
    } catch (error) {
      toast.error("Error al guardar la configuración.", {
        position: "top-right",
      });
      console.error("Error saving config:", error);
    }
  };

  const recuperar = async () => {
    try {
      const response = await getCfgFacte(getSession().ruc);
      if (response) {
        setFacturae(response);
        if (response.detActi) {
          setActividades(response.detActi);
        }
      }
    } catch (error) {
      toast.warning("No se pudieron recuperar los datos del servidor", {
        position: "top-right",
      });
    }
  };

  useEffect(() => {
    recuperar();
  }, []);

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <DataEmisor
            configuracion={facturae}
            handleChange={handleChange}
            validation={validation}
            toggleDepModal={toggleDepModal}
            toggleDisModal={toggleDisModal}
            toggleCiuModal={toggleCiuModal}
          />
        );
      case 1:
        return (
          <OperacionComercial
            configuracion={facturae}
            handleChange={handleChange}
            validation={validation}
            tipoTranOptions={tipoTranOptions}
            tipoImpOptions={tipoImpOptions}
            tipoRegOptions={tipoRegOptions}
            handleChangeSel={handleChangeSel}
          />
        );
      case 2:
        return (
          <ActividadesEconomicas
            GActEco={GActEco}
            setGActEco={setGActEco}
            actividades={actividades}
            setActividades={setActividades}
            upper={upper}
            setUpper={setUpper}
            addActividad={addActividad}
            eliminar={eliminarActividad}
            toggleActModal={toggleActModal}
            tooltip={tooltip}
            toggleTooltip={() => setTooltip(!tooltip)}
          />
        );
      default:
        return <Typography>Paso desconocido</Typography>;
    }
  };

  return (
    <Dialog fullWidth={true} maxWidth={"xl"} open={open} onClose={handleClose}>
      <DialogTitle>Datos del Emisor</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Con esta opción se configuran los datos del emisor del documento
          electrónico, en caso de utilizar el servicio (API Rest) de firma
          electrónica
        </DialogContentText>
        <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
          <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          <Box>
            {activeStep === steps.length ? (
              <Box sx={{ textAlign: "center", py: 4 }}>
                <Typography variant="h5" gutterBottom>
                  ¡Configuración Completada!
                </Typography>
                <Typography>
                  Los datos han sido guardados exitosamente.
                </Typography>
                <Button onClick={() => setActiveStep(0)} sx={{ mt: 3 }}>
                  Reiniciar Configuración
                </Button>
              </Box>
            ) : (
              <Fragment>
                {getStepContent(activeStep)}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 3,
                  }}
                >
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    Anterior
                  </Button>
                  <Button variant="contained" onClick={handleNext}>
                    {activeStep === steps.length - 1 ? "Grabar" : "Siguiente"}
                  </Button>
                </Box>
              </Fragment>
            )}
          </Box>
        </Paper>
        <ToastContainer />

        <ModalLisDep
          toggleModal={toggleDepModal}
          modalOpen={modalDepOpen}
          modalTitle="Lista de Departamentos"
          listaDep={listaDep}
          selecDep={selecDep}
          handleKeyUpDep={(e) =>
            setListaDep(
              JSON.parse(localStorage.getItem("listaDep")).filter((item) =>
                item.departamento
                  .toUpperCase()
                  .includes(e.target.value.toUpperCase())
              )
            )
          }
        />
        <ModalLisDis
          toggleModal={toggleDisModal}
          modalOpen={modalDisOpen}
          modalTitle="Lista de Distritos"
          listaDis={listaDis}
          selecDis={selecDis}
          handleKeyUpDis={(e) =>
            setListaDis(
              JSON.parse(localStorage.getItem("listaDis")).filter((item) =>
                item.distrito
                  .toUpperCase()
                  .includes(e.target.value.toUpperCase())
              )
            )
          }
        />
        <ModalLisCiu
          toggleModal={toggleCiuModal}
          modalOpen={modalCiuOpen}
          modalTitle="Lista de Ciudades"
          listaCiu={listaCiu}
          selecCiu={selecCiu}
          handleKeyUpCiu={(e) =>
            setListaCiu(
              JSON.parse(localStorage.getItem("listaCiu")).filter((item) =>
                item.ciudad.toUpperCase().includes(e.target.value.toUpperCase())
              )
            )
          }
        />
        <ModalLisActEco
          toggleModal={toggleActModal}
          modalOpen={modalActOpen}
          modalTitle="Lista de Actividades Económicas"
          listaActEco={list_with_filter}
          setSearch={setSearchActEco}
          selecAct={selecAct}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>volver</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FacteConfigMUI;
